import { render, staticRenderFns } from "./addMachineTranslate.vue?vue&type=template&id=9fac1326"
import script from "./addMachineTranslate.vue?vue&type=script&lang=js"
export * from "./addMachineTranslate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports